import type { AxiosInstance } from 'axios';
import type { Entities } from './interfaces/projects.js';

export class ProjectsEntitiesClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  fetchItems = (data: Entities.FetchItems.Request) => {
    return this.authenticatedClient.get<Entities.FetchItems.Response>(`/projects/${data.projectId}/entities`, {
      params: {
        index: data.index,
        size: data.size,
        sortBy: data.sortBy,
        sortDir: data.sortDir,
        nameFilter: data.nameFilter,
      },
    })
      .then(res => res.data);
  };

  addItems = ({ projectId, ...data }: Entities.AddItems.Request) => {
    return this.authenticatedClient.post<Entities.AddItems.Response>(`/projects/${projectId}/entities`, data);
  };

  modifyEntity = ({ projectId, ...data }: Entities.ModifyEntity.Request) => {
    return this.authenticatedClient.put<Entities.ModifyEntity.Response>(`/projects/${projectId}/entities`, data);
  };

  updateEntityBoost = ({ projectId, name, type, ...data }: Entities.UpdateEntityBoost.Request) => {
    return this.authenticatedClient.patch<Entities.UpdateEntityBoost.Response>(`/projects/${projectId}/entities/${encodeURIComponent(type)}/${encodeURIComponent(name)}`, data);
  };

  mergeEntities = ({ projectId, ...data }: Entities.MergeEntities.Request) => {
    return this.authenticatedClient.post<Entities.MergeEntities.Response>(`/projects/${projectId}/entities/merge`, data);
  };
}